import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../context/authContext";
import { FetchContext } from "../context/FetchContext";
import { Row, Spinner } from "react-bootstrap";
import ProjectCard from "../components/ProjectCard";
import { Navigate, useNavigate } from "react-router-dom";
const Projects = () => {
    const auth = useContext(AuthContext);
    const { authState } = auth;;
    const fetchContext = useContext(FetchContext);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(true);
    const [projObject, setPorjObject] = useState({});
    const [conObject, setConObject] = useState({});
    const [filterObject, setFilterObject] = useState({});
    const [noProj, setNoProj] = useState(false)
    const history = useNavigate();
    useEffect(() => {

        getProjects();
        setIsLoading(true);

    }, [refresh, authState]);

    async function getProjects() {
        try {
            await fetchContext.authAxios.get("/getprojects").then((res) => {
                // console.log(res)
                if (res.data.message === 'Session Expired') {
                    auth.logout()
                }
                if (res.data === 'no records') {
                    setNoProj(true)
                    setIsLoading(false)
                } else {
                    setPorjObject(res.data);
                    setFilterObject(res.data);
                    setNoProj(false)
                    setRefresh(false);
                    setIsLoading(false)
                }

            });
        } catch (error) {
            console.log(error);
        }
    }
    function projectsearch(e) {
        // console.log("prject searc")
        // console.log(e.target.value)
        var x = e.target.value.toLowerCase();
        let t = projObject.filter(proj => proj.fieldData.ProjectName.toLowerCase().includes(x) || proj.fieldData.Company_Name.toLowerCase().includes(x));
        // console.log(t)
        setFilterObject(t)
        setRefresh(false);

    }


    return (
        <>
            <h1 className="text-center">Projects</h1>
            <Row className="justify-content-center">
                {isLoading ? (
                    <>

                        <p className="pl-3 text-center">Gathering your projects.</p>
                        <Spinner animation="border" variant="danger" />


                    </>
                ) : (
                    <>
                        {noProj ? (
                            <Row className="text-center">
                                <h5 className="text-center">Uh oh.</h5>
                                <p className="text-center">We didn't find any projects you are assigned to.</p>
                            </Row>
                        ) : (
                            <>
                                <div className="text-center">
                                    <p className="mb-0 pb-0">Project Search</p> <br /> <input onInput={e => projectsearch(e)} id="projectsearch"
                                        className="mb-2 text-center inputsearch" placeholder="Project Name or Company" maxLength="75" type="text"></input>
                                </div>

                                {filterObject.length >= 1 ? (
                                    filterObject.map((project) => (
                                        <ProjectCard key={project.fieldData.ProjectID || project.fieldData.ProjectName} props={project} />
                                    ))
                                ) : (
                                    <Row className="text-center">
                                        <h5 className="text-center">Uh oh.</h5>
                                        <p className="text-center">We didn't find any projects you are assigned to.</p>
                                    </Row>
                                )}
                            </>

                        )}
                    </>
                )}

            </Row>
        </>
    )
}

export default Projects